const HS_VIDEO_COUNTERS = {
  COMPONENT_RENDER: 'hs-video-component-render',
  RENDERED_SUCCESSFULLY: 'hs-video-rendered-successfully',
  PLAY_CLICKED: 'hs-video-play-clicked',
  FAILED_TO_RENDER: 'hs-video-failed-to-render',
  MILESTONE: 'hs-video-milestone',
  PLAYED: 'hs-video-played',
  FINISHED: 'hs-video-finished',
  ENGAGED: 'hs-video-engaged'
};
export const HS_VIDEO_SURFACE = {
  LEARNING_CENTER_EMBEDDED_VIDEO: 'learning-center-embedded-video',
  EMBEDDED_ACADEMY_UI: 'embedded-academy-ui',
  ACADEMY_ONBOARDING_HERO: 'academy-onboarding-hero',
  ACADEMY_TO_SOFTWARE_MODAL: 'academy-to-software-modal',
  LEARNING_CENTER_VIDEO_PLAYER: 'learning-center-video-player'
};
function increment(metrics, name, tags) {
  metrics.counter(name, tags).increment();
}
export function trackHsVideoComponentRender(metrics, surface) {
  increment(metrics, HS_VIDEO_COUNTERS.COMPONENT_RENDER, {
    surface
  });
}
export function trackHsVideoRenderedSuccessfully(metrics, surface) {
  increment(metrics, HS_VIDEO_COUNTERS.RENDERED_SUCCESSFULLY, {
    surface
  });
}
export function trackHsVideoPlayClicked(metrics, tags) {
  increment(metrics, HS_VIDEO_COUNTERS.PLAY_CLICKED, tags);
}
export function trackHsVideoFailedToRender(metrics, tags) {
  increment(metrics, HS_VIDEO_COUNTERS.FAILED_TO_RENDER, tags);
}
export function trackHsVideoMilestone(metrics, threshold, surface) {
  increment(metrics, HS_VIDEO_COUNTERS.MILESTONE, {
    threshold,
    surface
  });
}
export function trackHsVideoPlayed(metrics, tags) {
  increment(metrics, HS_VIDEO_COUNTERS.PLAYED, tags);
}
export function trackHsVideoFinished(metrics, tags) {
  increment(metrics, HS_VIDEO_COUNTERS.FINISHED, tags);
}
export function trackHsVideoEngaged(metrics, tags) {
  increment(metrics, HS_VIDEO_COUNTERS.ENGAGED, tags);
}